import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function PadlockCardIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 30.898 30.898'} fontSize={'inherit'} {...props}>
      <path
        id="Tracé_50"
        data-name="Tracé 50"
        d="M31.252,15.291V7.027A2.5,2.5,0,0,0,30.466,5.2a2.5,2.5,0,0,0-1.823-.786H5.767A2.492,2.492,0,0,0,3.949,5.2a2.505,2.505,0,0,0-.784,1.823V24.5a2.5,2.5,0,0,0,.784,1.812,2.484,2.484,0,0,0,1.818.79H12.8a1.3,1.3,0,0,0,0-2.6H5.767V15.291ZM5.767,7.027H28.643v3.062H5.767Z"
        transform="translate(-0.834 -1.163)"
        fill="#333"
      />
      <path
        id="Tracé_51"
        data-name="Tracé 51"
        d="M31.974,34.558a.647.647,0,0,1-.648-.648V31.5a.648.648,0,0,1,1.3,0v2.409a.647.647,0,0,1-.648.648"
        transform="translate(-8.25 -8.126)"
        fill="#333"
      />
      <path
        id="Tracé_52"
        data-name="Tracé 52"
        d="M31.8,32.279a1.128,1.128,0,1,1,1.128-1.128A1.129,1.129,0,0,1,31.8,32.279m0-1.294a.167.167,0,0,0-.166.166c0,.184.333.184.333,0a.167.167,0,0,0-.166-.166"
        transform="translate(-8.078 -7.907)"
        fill="#333"
      />
      <path
        id="Tracé_53"
        data-name="Tracé 53"
        d="M33.888,35.883H26.475a2.025,2.025,0,0,1-2.022-2.022V28.328a2.025,2.025,0,0,1,2.023-2.023h7.411a2.026,2.026,0,0,1,2.021,2.022v5.53a2.023,2.023,0,0,1-2.02,2.026m0-8.284h-7.41a.729.729,0,0,0-.729.729v5.53a.73.73,0,0,0,.728.731h7.411a.728.728,0,0,0,.726-.73V28.327a.729.729,0,0,0-.727-.728"
        transform="translate(-6.44 -6.928)"
        fill="#333"
      />
      <path
        id="Tracé_54"
        data-name="Tracé 54"
        d="M34.636,25.546H33.341V24.187a1.706,1.706,0,0,0-1.7-1.7H30.133a1.706,1.706,0,0,0-1.7,1.7v1.358H27.144V24.187a3,3,0,0,1,2.987-2.99h1.515a3,3,0,0,1,2.989,2.988Z"
        transform="translate(-7.149 -5.582)"
        fill="#333"
      />
    </SvgIcon>
  );
}
